export default __webpack_public_path__ + "static/media/submit-icon.234dd916.svg";